import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import TaxDelinquentMap from './components/TaxDelinquentMap';
import OurServices from './components/OurServices';
import ServiceProcess from './components/ServiceProcess';
import ServiceTiersPreview from './components/ServiceTiersPreview';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="font-sans bg-[#090b10]">
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <TaxDelinquentMap />
        <OurServices />
        <ServiceProcess />
        <WhyChooseUs />
        <ServiceTiersPreview />
        <Testimonials />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
